import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { DocumentHead } from './components/DocumentHead';
import { HomePage } from './pages/HomePage';
import { PlateformePage } from './pages/PlateformePage';
import { AvantPage } from './pages/AvantPage';
import { PendantPage } from './pages/PendantPage';
import { ApresPage } from './pages/ApresPage';
import { InfrastructurePage } from './pages/InfrastructurePage';
import { ProchainementPage } from './pages/ProchainementPage';
import { TarifsPage } from './pages/TarifsPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <DocumentHead data-id="element-1" />
      <ScrollToTop data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
        <Route path="/plateforme" element={<PlateformePage data-id="element-7" />} data-id="element-6" />
        <Route path="/avant" element={<AvantPage data-id="element-9" />} data-id="element-8" />
        <Route path="/pendant" element={<PendantPage data-id="element-11" />} data-id="element-10" />
        <Route path="/apres" element={<ApresPage data-id="element-13" />} data-id="element-12" />
        <Route path="/infrastructure" element={<InfrastructurePage data-id="element-15" />} data-id="element-14" />
        <Route path="/prochainement" element={<ProchainementPage data-id="element-17" />} data-id="element-16" />
        <Route path="/tarifs" element={<TarifsPage data-id="element-19" />} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}